// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".336393bd7e6c52412005b28580d41e76ffe3c001.chunk.bundle.js";
};